export const userStatus = (status) => {
  let value;
  switch (status) {
    case "Yes":
    case true:
      value = "Да";
      break;
    case "No":
    case false:
      value = "Не";
      break;
    default:
      value = "Чакащ";
  }
  return value;
}

